(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('orderPickNew', {
        templateUrl: 'views/components/views/orderPickNew/orderPickNew.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: [
            '$stateParams',
            'utilityService',
            'translateService',
            'modalService',
            'orderPickNewService',
            'stockAssignService',
            'economyService',
            'typeaheadService',
            'ttGridFactory',
            function ($stateParams, utilityService, translateService, modalService, orderPickNewService, stockAssignService, economyService, typeaheadService, ttGridFactory) {
                // #region VARIABLES & DEFINITIONS

                const vm = this;
                let argType = $stateParams.argtype;
                let argValue = $stateParams.argvalue;

                let translations = {
                    error: '',
                    ok: '',
                };

                vm.model = {
                    gridStockBatchesReady: false,
                    gridPickedBeforeReady: false,
                    bgOrderPickNew: {
                        selected: 'PICKNOW',
                        buttons: [
                            { id: '', label: 'gb_orderpicknew_picknow', color: 'primary', onClick: () => (vm.model.bgOrderPickNew.selected = 'PICKNOW') },
                            { id: 'PICKEDBEFORE', label: 'gb_orderpicknew_pickedbefore', color: 'primary', onClick: () => (vm.model.bgOrderPickNew.selected = 'PICKEDBEFORE') },
                        ],
                    },
                    stockBatchButtons: [{ id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('stockbatch_keyno') }],
                    setting: {},
                    selectListLabours: [],
                    selectListProductUnits: [],
                    orderlines: [],
                    lockedSave: false,
                    distributing: false,
                };

                vm.gridStockBatches = new ttGridFactory({
                    rememberId: 'w_orderpick_stockbatch_grid',
                    kendo: {
                        height: '100%',
                        sortable: true,
                        aggregate: true,
                        pager: false,
                        selectable: false,
                        filterable: false,
                    },
                });

                vm.gridPickedBefore = new ttGridFactory({
                    rememberId: 'w_orderpick_pickedbefore_grid',
                    kendo: {
                        height: '100%',
                        sortable: true,
                        aggregate: true,
                        pager: false,
                        selectable: false,
                        filterable: false,
                    },
                });

                // #endregion VARIABLES & DEFINITIONS

                // #region TRANSLATE SERVICE

                async function translate() {
                    let data = await translateService.translateBatch(translations);

                    Object.keys(translations).forEach((key) => {
                        if (data?.[key]) translations[key] = data[key];
                    });
                }

                // #endregion TRANSLATE SERVICE

                // #region LOAD PROCEDURE FUNCTION CALLS

                async function loadSetting() {
                    vm.model.setting = (
                        await orderPickNewService.getSetting({
                            argtype: argType,
                            argvalue: argValue,
                        })
                    )[0];

                    loadOrderlines();
                    loadProductUnits();
                    loadLabours();

                    if (vm.model.setting.stock_keyno > 0) loadGridStockBatches();
                    loadGridPickedBefore();
                }

                async function loadProductUnits() {
                    if (utilityService.validateParmsValue(vm.model.setting.prod_id) !== true) return;

                    vm.model.selectListProductUnits = await stockAssignService.listProductUnits({ prod_id: vm.model.setting.prod_id });
                }

                async function loadOrderlines() {
                    vm.model.orderlines = await orderPickNewService.orderlines({ order_internal_no: vm.model.setting.order_internal_no });
                }

                async function loadLabours() {
                    if (utilityService.validateParmsValue(vm.model.setting.businessco_no, true) !== true) return;

                    vm.model.selectListLabours = await economyService.listLabours({ businessco_no: vm.model.setting.businessco_no });
                }

                function retrieveProductId() {
                    orderPickNewService.changeProductId(vm.model.setting).then((response) => {
                        vm.model.setting.stock_keyno = response[0].stock_keyno;
                        vm.model.setting.input_unit_no = response[0].input_unit_no;

                        retrieveQuantityStockUnits();
                        loadGridStockBatches();
                        loadGridPickedBefore();
                    });
                }

                function retrieveQuantityStockUnits() {
                    orderPickNewService.recalcQuantityStockUnits(vm.model.setting).then((response) => {
                        vm.model.setting.input_quantity_stock_units = response[0].input_quantity_stock_units;
                    });
                }

                // #endregion LOAD PROCEDURE FUNCTION CALLS

                // #region GRID PROCEDURE FUNCTION CALLS

                async function loadGridStockBatches() {
                    vm.gridStockBatches.dataTask.loadData = {
                        method: 3702,
                        parameters: vm.model.setting,
                    };

                    vm.model.gridStockBatchesReady = true;

                    if (vm.gridStockBatches.gridfunc !== null) vm.gridStockBatches.gridfunc.read();
                }

                async function loadGridPickedBefore() {
                    vm.gridPickedBefore.dataTask.loadData = {
                        method: 3707,
                        parameters: vm.model.setting,
                    };

                    vm.model.gridPickedBeforeReady = true;

                    if (vm.gridPickedBefore.gridfunc !== null) vm.gridPickedBefore.gridfunc.read();
                }

                // #endregion GRID PROCEDURE FUNCTION CALLS

                // #region MULTI CLEAR FUNCTION

                function clear(id) {
                    switch (id) {
                        case 'stockbatch_keyno':
                            vm.model.setting.stockbatch_keyno = '0';

                            if (vm.model.setting.stockbatch_keyno === '0') {
                                loadGridStockBatches();
                                loadGridPickedBefore();
                            }
                            break;
                        default:
                            break;
                    }
                }

                // #endregion MULTI CLEAR FUNCTION

                // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

                vm.typeaheadSearch = function (value, id) {
                    switch (id) {
                        case 'stockbatch_search':
                            vm.model.setting[id] = value;

                            return typeaheadService.lookUpStockBatch(vm.model.setting);
                            break;
                        case 'prod_name':
                            vm.model.setting[id] = value;

                            return typeaheadService.searchProduct({ prod_name: vm.model.setting[id] || '' });
                            break;
                        default:
                            break;
                    }
                };

                // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

                // #region SELECTED VALUE FUNCTION

                vm.onTypeaheadSelected = function (item, id) {
                    switch (id) {
                        case 'stockbatch_search':
                            if (item) {
                                vm.model.setting.stock_keyno = item?.stock_keyno ?? '0';
                                vm.model.setting.stockbatch_keyno = item?.item_id ?? '0';
                                vm.model.setting.stockbatch_search = item?.item_name ?? '';
                                vm.model.setting.prod_id = item?.prod_id ?? '';
                                vm.model.setting.prod_name = item?.prod_name ?? '';

                                loadProductUnits();
                                loadGridStockBatches();
                                loadGridPickedBefore();
                            } else {
                                vm.onTypeaheadClear('stockbatch_search');
                            }
                            break;
                        case 'prod_name':
                            if (item) {
                                vm.model.setting.prod_id = item?.item_id ?? '';
                                vm.model.setting.prod_name = item?.item_name ?? '';

                                loadProductUnits();
                                retrieveProductId();
                            } else {
                                vm.onTypeaheadClear('prod_name');
                            }
                            break;
                        default:
                            break;
                    }
                };

                // #endregion SELECTED VALUE FUNCTION

                // #region CHANGED VALUE FUNCTION

                vm.onTypeaheadChanged = function (value, item, id) {
                    switch (id) {
                        case 'stockbatch_search':
                            vm.model.setting.stockbatch_search = value;

                            if (value) {
                                if (item?.item_id) {
                                    vm.model.setting.stock_keyno = item.stock_keyno;
                                    vm.model.setting.stockbatch_keyno = item.item_id;
                                }
                            } else {
                                vm.onTypeaheadClear('stockbatch_search');
                            }
                            break;
                        case 'prod_name':
                            vm.model.setting.prod_name = value;

                            if (value) {
                                if (item?.item_id) {
                                    vm.model.setting.prod_id = item.item_id;
                                }
                            } else {
                                vm.onTypeaheadClear('prod_name');
                            }
                            break;
                        default:
                            break;
                    }
                };

                // #endregion CHANGED VALUE FUNCTION

                // #region CLEAR VALUE FUNCTION

                vm.onTypeaheadClear = function (id) {
                    switch (id) {
                        case 'stockbatch_search':
                            vm.model.setting.stock_keyno = '0';
                            vm.model.setting.stockbatch_keyno = '0';
                            vm.model.setting.stockbatch_search = '';
                            vm.model.setting.prod_id = '';
                            vm.model.setting.prod_name = '';

                            loadProductUnits();
                            loadGridStockBatches();
                            loadGridPickedBefore();
                            break;
                        case 'prod_name':
                            vm.model.setting.prod_id = '';
                            vm.model.setting.prod_name = '';

                            loadProductUnits();
                            retrieveProductId();
                            break;
                        default:
                            break;
                    }
                };

                // #endregion CLEAR VALUE FUNCTION

                // #region BUTTON SAVE PROCEDURE FUNCTION CALL

                vm.saveChanges = function () {
                    vm.model.lockedSave = true;

                    if (vm.model.gridStockBatchesReady === true) {
                        let currentData = [];
                        let selectedRows = [];
                        let mergeObj = {};
                        currentData = vm.gridStockBatches.gridfunc.getAllRows();

                        currentData.forEach((item) => {
                            selectedRows.push({
                                stockbatch_keyno: item.stockbatch_keyno,
                                quantity_pick_now: item.quantity_pick_now,
                            });
                        });

                        mergeObj = vm.model.setting;
                        mergeObj.records = selectedRows;

                        orderPickNewService.saveObj(mergeObj).then((response) => {
                            if (response[0] && response[0].errorcode !== '0') {
                                modalService.show({
                                    type: 'warning',
                                    title: translations.error,
                                    message: response[0].errormessage,
                                    buttons: [
                                        {
                                            label: translations.ok,
                                            cssClass: 'btn-warning',
                                            action: function (dialogItself) {
                                                dialogItself.close();
                                                vm.model.lockedSave = false;
                                            },
                                        },
                                    ],
                                });
                            } else {
                                vm.model.lockedSave = false;

                                if (window.location.hash.includes('ispopup')) {
                                    window.opener.postMessage('popupClosed');
                                    setTimeout(() => window.close(), 0);
                                }
                            }
                        });
                    } else {
                        orderPickNewService.saveObj(vm.model.setting).then((response) => {
                            if (response[0] && response[0].errorcode !== '0') {
                                modalService.show({
                                    type: 'warning',
                                    title: translations.error,
                                    message: response[0].errormessage,
                                    buttons: [
                                        {
                                            label: translations.ok,
                                            cssClass: 'btn-warning',
                                            action: function (dialogItself) {
                                                dialogItself.close();
                                                vm.model.lockedSave = false;
                                            },
                                        },
                                    ],
                                });
                            } else {
                                vm.model.lockedSave = false;

                                if (window.location.hash.includes('ispopup')) {
                                    window.opener.postMessage('popupClosed');
                                    setTimeout(() => window.close(), 0);
                                }
                            }
                        });
                    }
                };

                // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

                // #region BUTTON DISTRIBUTE PROCEDURE FUNCTION CALL

                vm.distributeChanges = function () {
                    vm.model.distributing = true;

                    if (vm.model.gridStockBatchesReady === true) {
                        let currentData = [];
                        let selectedRows = [];
                        let updatedRows = [];
                        let mergeObj = {};
                        currentData = vm.gridStockBatches.gridfunc.getAllRows();

                        currentData.forEach((item) => {
                            selectedRows.push({
                                stockbatch_keyno: item.stockbatch_keyno,
                                quantity_pick_now: item.quantity_pick_now,
                            });
                        });

                        mergeObj = vm.model.setting;
                        mergeObj.records = selectedRows;

                        orderPickNewService.distributeObj(mergeObj).then((list) => {
                            vm.model.distributing = false;
                            updatedRows = list;

                            // Create a lookup map from updatedRows
                            let lookup = Object.fromEntries(updatedRows.map(({ stockbatch_keyno, quantity_picked_now }) => [stockbatch_keyno, quantity_picked_now]));

                            // Update currentData in-place where stockbatch_keyno match
                            currentData.forEach((obj) => {
                                if (lookup.hasOwnProperty(obj.stockbatch_keyno)) {
                                    obj.quantity_pick_now = lookup[obj.stockbatch_keyno];
                                }
                            });

                            vm.gridStockBatches.gridfunc.refresh();
                        });
                    }
                };

                // #endregion BUTTON DISTRIBUTE PROCEDURE FUNCTION CALL

                // #region BUTTON RADIO FUNCTIONS

                vm.selectBgOrderPickNew = function (value) {
                    vm.model.bgOrderPickNew.selected = value;
                };

                // #endregion BUTTON RADIO FUNCTIONS

                // #region ON BLUR MULTI FUNCTIONS

                vm.onBlur = function (id) {
                    switch (id) {
                        case 'input_quantity':
                            if (utilityService.validateParmsValue(vm.model.setting.input_quantity, true) !== true) return;

                            retrieveQuantityStockUnits();
                            break;
                        default:
                            break;
                    }
                };

                // #endregion ON BLUR MULTI FUNCTIONS

                // #region FIELD CHANGE MULTI FUNCTIONS

                vm.onChanged = function (value, id) {
                    switch (id) {
                        case 'input_unit_no':
                            if (utilityService.validateWatchValue(value, vm.model.setting[id]) !== true) return;

                            vm.model.setting[id] = value;

                            if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

                            retrieveQuantityStockUnits();
                            break;
                        default:
                            utilityService.setValueToVariable(value);
                            break;
                    }
                };

                // #endregion FIELD CHANGE MULTI FUNCTIONS

                // #region ON INIT FUNCTION

                vm.$onInit = function () {
                    translate();
                    loadSetting();
                };

                // #endregion ON INIT FUNCTION
            },
        ],
    });
})();
